export enum PageCrud {
  ADD = 'add',
  EDIT = 'edit',
  SHOW = 'show',
}
